var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: " currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m10.519 16.772-1.7-11.696c-.513-2.62-4.815-2.62-5.306 0L1.148 17.084m12.333-.312 1.714-11.696c.439-2.656 4.772-2.878 5.306 0l2.365 12.008M9.462 9.497H14.5m5.806 8.77c.113 1.233-.819 2.316-2.081 2.421m-9.919-2.42c.113 1.232-.819 2.315-2.081 2.42m3.76-7.593H14M5.889 23C3.189 23 1 20.89 1 18.29c0-2.603 2.189-4.712 4.889-4.712s4.889 2.11 4.889 4.711c0 2.602-2.189 4.711-4.89 4.711Zm12.222 0c-2.7 0-4.889-2.11-4.889-4.71 0-2.603 2.19-4.712 4.89-4.712 2.7 0 4.888 2.11 4.888 4.711C23 20.891 20.811 23 18.111 23Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViews);
export default __webpack_public_path__ + "static/media/views.6c6999013f3438975fdf5ecb3a4027ac.svg";
export { ForwardRef as ReactComponent };